import { Injectable, inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateFn,
    CanActivateChildFn,
    Router,
} from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { TranslateService } from '../../../shared/modules/translate/translate.service';


export const AnonymousGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const authGuardService = inject(AuthGuardService);
    const translationService = inject(TranslateService);
    //Back To Portal If User Already Logged In
    if (authGuardService.isLoggedIn()) {
        const router = inject(Router);
        router.navigate(['/', translationService.lastLang])
        //   alert('You can not access to this page because you already logged in')
        return false;
    }
    return true;
};

